import { Box } from "@cjdev-internal/visual-stack-x/Box";
import { Text } from "@cjdev-internal/visual-stack-x/Text";
import Case from "case";
import { NULL_STATE_METRIC_PLACEHOLDER } from "constants/metrics";
import { useIntl } from "hooks";
import globalMessages from "messages/globalMessages";
import * as R from "ramda";
import React from "react";
import "../styles.css";

export const RateMetric = ({ name, value }) => {
  const intl = useIntl();
  return (
    <Box
      key={name}
      data-testid={name}
      direction="column"
      gap="medium"
      align="center"
      className="social-stat"
    >
      <Text weight="medium" size={18}>
        {R.isNil(value)
          ? NULL_STATE_METRIC_PLACEHOLDER
          : `${Math.max(value, 0.01).toFixed(2)}%`}
      </Text>
      <Text size={12} className="social-stat-center">
        {globalMessages[name]
          ? Case.capital(intl.formatMessage(globalMessages[name]))
          : name}
      </Text>
    </Box>
  );
};
